"use client";
import React, { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';

const ReadMoreIcon = () => (
  <svg width="29" height="24" viewBox="0 0 29 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_readmore)">
      <path d="M15.695 16.83L20.5 12L15.695 7.16998C15.6516 7.11299 15.5965 7.066 15.5333 7.03217C15.4702 6.99834 15.4005 6.97848 15.329 6.97392C15.2576 6.96935 15.1859 6.98021 15.119 7.00573C15.0521 7.03126 14.9914 7.07087 14.9411 7.12188C14.8909 7.17289 14.8521 7.23411 14.8275 7.30139C14.803 7.36867 14.7931 7.44045 14.7987 7.51186C14.8043 7.58327 14.8252 7.65265 14.8599 7.7153C14.8946 7.77795 14.9424 7.8324 15 7.87498L18.595 11.5L9.03 11.5C8.89739 11.5 8.77022 11.5527 8.67645 11.6464C8.58268 11.7402 8.53 11.8674 8.53 12C8.53 12.1326 8.58268 12.2598 8.67645 12.3535C8.77022 12.4473 8.89739 12.5 9.03 12.5L18.595 12.5L15 16.125C14.9065 16.2191 14.8543 16.3466 14.8547 16.4792C14.8552 16.6119 14.9083 16.739 15.0025 16.8325C15.0967 16.926 15.2241 16.9782 15.3568 16.9778C15.4894 16.9773 15.6165 16.9241 15.71 16.83H15.695Z" fill="#0C0C0C" />
    </g>
    <rect x="26" y="2.5" width="19" height="23" rx="9.5" transform="rotate(90 26 2.5)" stroke="#0C0C0C" />
    <defs>
      <clipPath id="clip0_readmore">
        <rect x="25.5" y="3" width="18" height="22" rx="9" transform="rotate(90 25.5 3)" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const FeaturedSlide = ({ blog }) => (
  <div className="row align-items-center">
    <div className="col-lg-6">
      <div className="featured-blog-content-bp">
        <h2 className="featured-blog-label-bp">FEATURED Articles</h2>
        <h1 className="featured-blog-title-bp">{blog.title}</h1>
        <p className="featured-blog-description-bp">{blog.description}</p>
        <div className="featured-blog-meta-bp">
          <span className="featured-blog-author-bp">{blog.author}</span>
          <span className="featured-blog-separator-bp">|</span>
          <span className="featured-blog-date-bp">{blog.date}</span>
        </div>
        <Link
          href={blog.slug ? `/article/${blog.slug}` : '/articles'}
          className="featured-blog-button-bp"
          style={{ textDecoration: 'none' }}
        >
          Read More
          <ReadMoreIcon />
        </Link>
      </div>
    </div>
    <div className="col-lg-6">
      <div className="featured-blog-image-wrapper-bp">
        <div className="featured-blog-image-bp">
          <Image
            src={blog.image && typeof blog.image === 'string' && blog.image.trim() ? blog.image : '/icons/hero.png'}
            alt={blog.title || 'Featured blog image'}
            width={600}
            height={400}
            className="img-fluid"
          />
        </div>
      </div>
    </div>
  </div>
);

const FeaturedArticlesCarousel = ({ slides = [] }) => {
  const [index, setIndex] = useState(0);

  if (!slides.length) return null;

  // Single featured article: render statically without carousel controls.
  if (slides.length === 1) {
    return (
      <section className="featured-blog-section-bp">
        <div className="container">
          <FeaturedSlide blog={slides[0]} />
        </div>
      </section>
    );
  }

  const goTo = (i) => setIndex((i + slides.length) % slides.length);
  const goPrev = () => goTo(index - 1);
  const goNext = () => goTo(index + 1);

  return (
    <section className="featured-blog-section-bp">
      <div className="container">
        <div className="featured-carousel-bp">
          <button
            type="button"
            className="featured-carousel-arrow-bp prev"
            aria-label="Previous featured article"
            onClick={goPrev}
          >
            <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 1L1 8L8 15" stroke="#0D2469" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          <FeaturedSlide blog={slides[index]} />

          <button
            type="button"
            className="featured-carousel-arrow-bp next"
            aria-label="Next featured article"
            onClick={goNext}
          >
            <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 1L9 8L2 15" stroke="#0D2469" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>

        <div className="featured-carousel-dots-bp">
          {slides.map((_, i) => (
            <button
              key={i}
              type="button"
              className={`featured-carousel-dot-bp ${i === index ? 'active' : ''}`}
              aria-label={`Go to featured article ${i + 1}`}
              onClick={() => goTo(i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedArticlesCarousel;
